import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_10: FaireProductEntity = {
  token: "atc_updated_moma_10",
  type: "product",
  name: "Miffy Bicycle Mug",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/43c1d3133b391fc4264dbade7ee569fb02586b600d05708ae7d0c312fa64bc98.webp",
  priceDollars: 22,
  msrpDollars: 28,
  description: "Miffy illustration ceramic mug.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
